/**
 * Supported Browsers
 *
 * @class rlSupportedBrowsers
 * @memberOf jQuery.fn
 */
(function ($) {

    $.fn.rlSupportedBrowsers = function () {

        // Configuration should be pulled from
        // data attributes on the body entered via the CMS

        var config = {
            msie: $('body').data('msie'),
            msedge: $('body').data('msedge'),
            chrome: $('body').data('chrome'),
            mozilla: $('body').data('mozilla'),
            safari: $('body').data('safari'),
            browserName: '',
            toastMessageContainer: $('#unsupported-browser-message'),
            actualBrowserVersion: $.browser.versionNumber
        }

        // Check browser and version
        // Uses "~/src/assets/js/vendor/jquery.browser.min.js"
        // https://github.com/gabceb/jquery-browser-plugin

        var checkBrowser = function () {
            // Internet Explorer
            if ($.browser.msie === true) {
                config.browserName = 'Internet Explorer';
                checkSupport(config.browserName, config.actualBrowserVersion, config.msie);
            }

            // Microsoft Edge
            else if ($.browser.msedge === true) {
                config.browserName = 'Microsoft Edge';
                checkSupport(config.browserName, config.actualBrowserVersion, config.msedge);
            }

            // Chrome
            else if ($.browser.chrome === true) {
                config.browserName = 'Chrome';
                checkSupport(config.browserName, config.actualBrowserVersion, config.chrome);
            }

            // Firefox
            else if ($.browser.mozilla === true) {
                config.browserName = 'Firefox';
                checkSupport(config.browserName, config.actualBrowserVersion, config.mozilla);
            }

            // Safari
            else if ($.browser.safari === true) {
                config.browserName = 'Safari';
                checkSupport(config.browserName, config.actualBrowserVersion, config.safari);
            }

            // Unknown Browsers
            else {
                config.browserName = 'Unknown';
                checkSupport(true);
            }
        };

        //  Compare actual version via entered version
        var checkSupport = function (browser, actual, configValue) {

            // Trigger toast message if conditions not met
            if ((actual < configValue) || (browser === false)) {
                config.toastMessageContainer.addClass('show');
            }

        };

        //checkBrowser();
        //the line below fires the function from the rl-Cookie.js function
        $.fn.rlSupportedBrowsers.checkBrowser = checkBrowser;

  };

}(jQuery));



